import { render, staticRenderFns } from "./categoryDialog.vue?vue&type=template&id=38a08d4c&scoped=true&"
import script from "./categoryDialog.vue?vue&type=script&lang=js&"
export * from "./categoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./categoryDialog.vue?vue&type=style&index=0&id=38a08d4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a08d4c",
  null
  
)

export default component.exports